import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer } from 'recharts';
import Container from '@mui/material/Container';

import { useAppSelector } from '../../../hooks';
import { selectBreakPoints } from '../../../Slices/appSlicer'
import { chartInnerFont} from '../style'
import { useTheme } from '@emotion/react';
import '../index.css'

const data = [
    { name: 'Lights Kitchen', value: 16 },
    { name: 'Smart TV', value: 15 },
    { name: 'Security  Cameras', value: 18 },
    { name: 'Lights Master Bedroom', value: 20 },
    { name: 'Lights Living Room', value: 22 },
    { name: 'Heaters', value: 24 },
    { name: 'AC Master Bedroom', value: 26 },
    { name: 'AC Living Room', value: 28 },
];

const RenderActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value  } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text  className='chart-inner-font' x={cx} y={cy} dy={8} textAnchor="middle" fill={"#FFFFFF"}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#FFFFFF">{`${value} kWh`}</text>
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                {`(Rate ${(percent * 100).toFixed(2)}%)`}
            </text>
        </g>
    );
};

const EnergyTab = () => {
    const theme = useTheme()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const [chartDimension , setChartDimension] = useState<{width: number, height: number}>({width: 800, height:400})
    const [radius , setRadius] = useState<{inner: number, outer: number}>({inner: 100, outer:140})

    const breakpoints = useAppSelector(selectBreakPoints)

    const onPieEnter = (e: Event, index: number) => {
        setActiveIndex(index)
    }
    useEffect(() => {
        if(breakpoints.ipadPotrait){
          setChartDimension({width: 600, height: 300})
        } else if(breakpoints.iphonePotrait){
          setChartDimension({width: 350, height: 300})
          setRadius({inner: 50 , outer: 70})
        }
       
      },[breakpoints])
    return (
        // <ResponsiveContainer width="100%" height="100%">
        <Container maxWidth="lg" sx={{ mt: 4 }}>

            <PieChart width={chartDimension.width} height={chartDimension.height}>
                <Pie
                   
                    activeIndex={activeIndex}
                    activeShape={RenderActiveShape}
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={radius.inner}
                    outerRadius={radius.outer}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnter}
                />
            </PieChart>
        </Container>

        // </ResponsiveContainer>
    );
}

export default EnergyTab